module.exports = __webpack_public_path__ + "static/media/Website.7c11c333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/MunafaMart/Website.jpg
// module id = 339
// module chunks = 0